import { useMutation } from "react-query";
import RecipientService from "../../services/recipient-data-service/RecipientDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { IRecipientEditDTO } from "../../services/recipient-data-service/Models";

export type UseCheckRecipientParameters = {
    groupID: number,
} & BaseUseMutationParameters<IRecipientEditDTO, IRecipientEditDTO>;

export function useCheckRecipient({
    groupID,
    onError,
    onSuccess
}: UseCheckRecipientParameters) {

    return useMutation<IRecipientEditDTO, RestError, IRecipientEditDTO>(
        async (model) => {
            await RecipientService.checkRecipient(
                groupID,
                model
            );

            return Promise.resolve(model);
        },
        {
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}
